<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Relatório Caixa Diário - Completo</h3>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs4 md3 text-xs-right>
        <v-select
          v-model="mes"
          color="secondary"
          :items="meses"
          :options="meses"
          label="Mês"
        ></v-select>
      </v-flex>
      <v-flex xs4 md3 text-xs-right>
        <v-select
          v-model="ano"
          color="secondary"
          :items="anos"
          :options="anos"
          label="Ano"
        ></v-select>
      </v-flex>
      <v-flex xs3 text-xs-right>
        <v-switch
          :label="`${pesquisaModel.ativo ? 'Unidade' : 'Todas Unidades'}`"
          v-model="pesquisaModel.ativo"
          :disabled="usuarioLogado.idtipousuario != perfilUsr.ID.administrador"
          color="primary"
        ></v-switch>
      </v-flex>
      <v-flex xs4 md3 text-xs-right>
        <v-btn
          id="finalizar"
          color="primary"
          class="default-border"
          depressed
          @click="buscarDados()"
          >Pesquisar
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-layout row wrap>
            <v-flex xs12 lg2>
              <v-card color="blue" class="white--text">
                <v-card-title primary-title>
                  <div>
                    <div class="headline">Total Ag.: {{ totalAgendas }}</div>
                    <span class="subheading mr-2"
                      >Total Ativas: {{ totalAgendasAtivas }}</span
                    >
                    <br />
                    <span class="subheading mr-2"
                      >Total Canc.: {{ totalAgendasCanceladas }}</span
                    >
                    <br />
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex xs12 lg5>
              <v-card color="green" class="white--text">
                <v-card-title primary-title>
                  <div>
                    <div class="headline">
                      Total À vista:
                      {{
                        totalAvista.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd {{ totalQtdAvista }}
                    </div>
                    <span class="subheading mr-2"
                      >Total Dinheiro:
                      {{
                        totalDinheiro.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd. {{ totalQtdDinheiro }}</span
                    >
                    <br />
                    <span class="subheading mr-2"
                      >Total Pix:
                      {{
                        totalPix.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd. {{ totalQtdPix }}</span
                    >
                    <br />
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex xs12 lg5>
              <v-card color="yellow" class="white--text">
                <v-card-title primary-title>
                  <div>
                    <div class="headline">
                      Total Cartão:
                      {{
                        totalCartao.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd {{ totalQtdCartao }}
                    </div>
                    <span class="subheading mr-2"
                      >Total Cartão À vista:
                      {{
                        totalDebito.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd. {{ totalQtdDebito }}</span
                    >
                    <br />
                    <span class="subheading mr-2"
                      >Total Cartão Parc.:
                      {{
                        totalParcelado.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                      - Qtd. {{ totalQtdParcelado }}</span
                    >
                    <br />
                  </div>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="listaInfo"
            class="elevation-1"
            :search="filtro"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>
                {{ customFormatComputed.toLocaleDateString(props.item.data) }}
              </td>
              <td>
                {{ props.item.conta }}
              </td>
              <td>
                {{ props.item.agendasTotal }}
              </td>
              <td>
                {{ props.item.agendasAtivas }}
              </td>
              <td>
                {{ props.item.agendasCanceladas }}
              </td>
              <td>
                {{
                  props.item.totalPagamentos.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{
                  props.item.totalVendaDinheiro.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.qtdVendaDinheiro }}
              </td>
              <td>
                {{
                  props.item.totalVendaPix.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.qtdVendaPix }}
              </td>
              <td>
                {{
                  props.item.totalVendaDebito.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.qtdVendaDebito }}
              </td>
              <td>
                {{
                  props.item.totalVendaCartaoAvista.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.qtdVendaCartaoAvista }}
              </td>
              <td>
                {{
                  props.item.totalVendaCartaoParcelado.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.qtdVendaCartaoParcelado }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import usuarioHelper from "@/helpers/usuario.js";
import cipher from "@/helpers/cipher.js";
import perfil from "@/helpers/perfil.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";

export default {
  name: "CaixaDiarioCompleto",
  data: () => ({
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    pesquisaModel: {
      ativo: true,
    },
    ano: null,
    mes: null,
    meses: [
      { value: "1", text: "Jan" },
      { value: "2", text: "Fev" },
      { value: "3", text: "Mar" },
      { value: "4", text: "Abr" },
      { value: "5", text: "Mai" },
      { value: "6", text: "Jun" },
      { value: "7", text: "Jul" },
      { value: "8", text: "Ago" },
      { value: "9", text: "Set" },
      { value: "10", text: "Out" },
      { value: "11", text: "Nov" },
      { value: "12", text: "Dez" },
    ],
    anos: [
      { value: "2020", text: "2020" },
      { value: "2021", text: "2021" },
      { value: "2022", text: "2022" },
      { value: "2023", text: "2023" },
      { value: "2024", text: "2024" },
      { value: "2025", text: "2025" },
      { value: "2026", text: "2026" },
    ],
    totalAgendas: 0,
    totalAgendasCanceladas: 0,
    totalAgendasAtivas: 0,

    totalAvista: 0.0,
    totalPix: 0.0,
    totalDinheiro: 0.0,

    totalQtdAvista: 0.0,
    totalQtdPix: 0.0,
    totalQtdDinheiro: 0.0,

    totalCartao: 0.0,
    totalDebito: 0.0,
    totalParcelado: 0.0,

    totalQtdCartao: 0.0,
    totalQtdDebito: 0.0,
    totalQtdParcelado: 0.0,

    filtro: "",
    pagination: { sortBy: "data", descending: true, rowsPerPage: 20 },
    headers: [
      { text: "Mês-Ano", value: "data" },
      { text: "Franquia", value: "conta" },
      { text: "Agendados", value: "agendasTotal" },
      { text: "Ag. Realizadas", value: "agendasAtivas" },
      { text: "Ag Canceladas", value: "agendasCanceladas" },
      { text: "Total Caixa", value: "totalPagamentos" },
      { text: "Total Dinheiro", value: "totalVendaDinheiro" },
      { text: "Qtd Dinheiro", value: "qtdVendaDinheiro" },
      { text: "Total Pix", value: "totalVendaPix" },
      { text: "Qtd Pix", value: "qtdVendaPix" },
      { text: "Total Debito", value: "totalVendaDebito" },
      { text: "Qtd Debito", value: "qtdVendaDebito" },
      { text: "Total C.Avista", value: "totalVendaCartaoAvista" },
      { text: "Qtd C. Avista", value: "qtdVendaCartaoAvista" },
      { text: "Total C. Parc", value: "totalVendaCartaoParcelado" },
      { text: "Qtd C. Parc", value: "qtdVendaCartaoParcelado" },
    ],
    listaInfo: [],
  }),
  mounted: function () {
    this.externalSnackbarMessage();
    this.ano = new Date().getFullYear() + "";
    this.mes = new Date().getMonth() + 1 + "";
  },
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
    perfilUsr: function () {
      return perfil;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
  },
  methods: {
    buscarDados: function () {
      const self = this;

      self.totalAgendas = 0;
      self.totalAgendasCanceladas = 0;
      self.totalAgendasAtivas = 0;

      self.totalAvista = 0.0;
      self.totalPix = 0.0;
      self.totalDinheiro = 0.0;

      self.totalQtdAvista = 0.0;
      self.totalQtdPix = 0.0;
      self.totalQtdDinheiro = 0.0;

      self.totalCartao = 0.0;
      self.totalDebito = 0.0;
      self.totalParcelado = 0.0;

      self.totalQtdCartao = 0.0;
      self.totalQtdDebito = 0.0;
      self.totalQtdParcelado = 0.0;

      if (self.pesquisaModel.ativo) {
        self.$http
          .get(
            `${process.env.URL_API}/contasreceber/v1/busca/relatoriodiario/completo/conta/` +
              jwt.decryptToken().idconta +
              `/mes/` +
              self.mes +
              `/ano/` +
              self.ano,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaInfo = response.data;

            if (response.data.length > 0) {
              self.listaInfo.forEach((e) => {
                self.bindDashboad(e);
              });
            }
          });
      } else {
        self.$http
          .get(
            `${process.env.URL_API}/contasreceber/v1/busca/relatoriodiario/completo/mes/` +
              self.mes +
              `/ano/` +
              self.ano,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaInfo = response.data;

            if (response.data.length > 0) {
              self.listaInfo.forEach((e) => {
                self.bindDashboad(e);
              });
            }
          });
      }
    },
    bindDashboad: function (e) {
      const self = this;
      //console.log(e);
      self.totalAgendas = e.agendasTotal + self.totalAgendas;
      self.totalAgendasCanceladas =
        self.totalAgendasCanceladas + e.agendasCanceladas;
      self.totalAgendasAtivas = self.totalAgendasAtivas + e.agendasAtivas;
      self.totalAvista =
        self.totalAvista + e.totalVendaDinheiro + e.totalVendaPix;
      self.totalPix = self.totalPix + e.totalVendaPix;
      self.totalDinheiro = self.totalDinheiro + e.totalVendaDinheiro;
      self.totalQtdAvista =
        e.qtdVendaPix + self.totalQtdAvista + e.qtdVendaDinheiro;
      self.totalQtdPix = e.qtdVendaPix + self.totalQtdPix;
      self.totalQtdDinheiro = e.qtdVendaDinheiro + self.totalQtdDinheiro;

      self.totalCartao =
        e.totalVendaDebito +
        e.totalVendaCartaoAvista +
        e.totalVendaCartaoParcelado +
        self.totalCartao;

      self.totalDebito = e.totalVendaDebito + self.totalDebito;

      self.totalParcelado = e.totalVendaCartaoParcelado + self.totalParcelado;

      self.totalQtdCartao =
        e.qtdVendaCartaoAvista +
        e.qtdVendaCartaoParcelado +
        e.qtdVendaDebito +
        self.totalQtdCartao;
      self.totalQtdDebito = e.qtdVendaDebito + self.totalQtdDebito;
      self.totalQtdParcelado =
        e.qtdVendaCartaoParcelado + self.totalQtdParcelado;
    },
    goEdit: function (id) {
      const self = this;
      self.$router.push({ name: "CadastroConta", params: { id: id } });
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/relatorio/CaixaDiarioCompleto.vue